import React from "react";
import { CircularProgress } from "@cdk-uip/react-circular-progress";

function Loader() {
  return (
    <div className="loading">
      <CircularProgress />
      <h5 style={{ marginTop: "0px", marginLeft: "-0.5pc" }}>loading...</h5>
    </div>
  );
}

export default Loader;
